import React from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/layout.css'; // Ensure you have styles applied

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Header />
      <div className="content">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;